<template>
    <div class="cabinet-content-wrap">
        <HeaderPublic />

        <section class="cabinet__breadcrumbs">
            <router-link to="/" class="cabinet__breadcrumbs-link"
                >Главная</router-link
            >
            <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
            <router-link to="/catalog" class="cabinet__breadcrumbs-link"
                >Каталог</router-link
            >
            <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
            <a
                v-if="publicSearchGlobal || routeParamsId === 'all'"
                href="javascript:void(0)"
                class="cabinet__breadcrumbs-link"
                >Все изделия</a
            >
            <template v-else-if="category">
                <template v-if="category.parent">
                    <router-link
                        :to="`/catalog/category/${category.parent.url}`"
                        class="cabinet__breadcrumbs-link"
                        >{{ category.parent.name }}</router-link
                    >
                    <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
                </template>
                <a
                    href="javascript:void(0)"
                    class="cabinet__breadcrumbs-link"
                    >{{ category.name }}</a
                >
            </template>
        </section>

        <div class="cabinet__product-page">
            <transition name="fade" mode="out-in">
                <h1
                    v-if="!publicSearchGlobal && routeParamsId === 'all'"
                    key="1"
                    class="h1"
                >
                    Все изделия
                </h1>
                <h1 v-else-if="publicSearchGlobal" key="2" class="h1">
                    Поиск по запросу - {{ publicSearchGlobal }}
                </h1>
                <h1 v-else-if="category" key="4" class="h1">
                    {{ category.h1 }}
                </h1>
            </transition>

            <div
                v-if="
                    category &&
                        category.children &&
                        category.children.length > 0
                "
                class="cabinet__product-page__filters_wrap"
            >
                <!-- <div
                    ref="prev"
                    :class="{ quick: !isBeginning, hide: isBeginning }"
                    class="cabinet__product-page__filters-arrow prev"
                >
                    <img src="/img/arrow_forward.svg" alt="" />
                </div> -->
                <div ref="swiperContainer" class="swiper-container">
                    <div class="cabinet__product-page__filters swiper-wrapper">
                        <div
                            v-for="subCategory in category.children"
                            :key="subCategory.id"
                            ref="swiperSlide"
                            class="swiper-slide"
                        >
                            <router-link
                                :to="`/catalog/category/${subCategory.url}`"
                                class="cabinet__product-page__filters-item"
                            >
                                <div
                                    v-if="subCategory.image_url"
                                    class="cabinet__product-page__filters-icon"
                                >
                                    <img
                                        :src="subCategory.image_url"
                                        :alt="subCategory.name"
                                    />
                                </div>
                                <span
                                    class="cabinet__product-page__filters-title"
                                    >{{ subCategory.name }}</span
                                >
                            </router-link>
                        </div>
                    </div>
                </div>
                <!-- <div
                    v-if="isButtonNext"
                    :class="{ quick: !isEnd, hide: isEnd }"
                    class="cabinet__product-page__filters-arrow next"
                >
                    <img src="/img/arrow_forward.svg" alt="" />
                </div> -->
            </div>

            <brand-products
                ref="product-list"
                :brand="brand"
                :request-for-categories="true"
                :is-category-page="true"
            />

            <div v-if="category" class="cabinet__product-page__note">
                <!-- <h2 class="h2">SEO текст</h2> -->
                <p>{{ category.seo_text }}</p>
                <!-- <a href="javascript:void(0)" class="h4">Читать дальше</a> -->
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'

import BrandProducts from '@/components/Public/Brand/Products'
import HeaderPublic from '@/components/Public/PublicHeader'

import vClickOutside from 'v-click-outside'

export default {
    name: 'CategoryID',
    components: {
        BrandProducts,
        HeaderPublic
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    data() {
        return {
            routeParamsId: this.$route.params.id,
            brand: {},
            swiperSlider: null,
            isButtonNext: true
        }
    },
    computed: {
        isBeginning() {
            return this.swiperSlider ? this.swiperSlider.isBeginning : true
        },
        isEnd() {
            return this.swiperSlider ? this.swiperSlider.isEnd : true
        },
        ...mapGetters({
            publicSearchGlobal: 'publicSearchGlobal'
        }),
        ...mapGetters('publicCategories', ['category'])
    },
    async created() {
        this.clearCategory()
        if (this.$route.params.id === 'all') {
            document.title = 'Все изделия'
            document.getElementsByTagName('meta')['description'].content =
                'Все изделия'
        } else {
            await this.getCategory(this.$route.params.id)

            document.title = this.category.title
            document.getElementsByTagName('meta')[
                'description'
            ].content = this.category.description
        }
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.swiperSlider = new Swiper('.swiper-container', {
                    slidesPerView: 'auto',
                    mousewheel: {
                        sensitivity: 5,
                        releaseOnEdges: true
                    },
                    navigation: {
                        nextEl: '.next',
                        prevEl: '.prev',
                        disabledClass: 'hide'
                    }
                })
            }, 1000)
        })
    },
    beforeRouteEnter(to, from, next) {
        /*if (from.name !== 'RetailerProductID' && from.name !== 'ProductID') {
            localStorage.removeItem('retailer-catalog-data')
        }*/
        localStorage.removeItem('retailer-catalog-data')

        next()
    },
    beforeRouteLeave(to, from, next) {
        /*if (to.name === 'RetailerProductID' || from.name !== 'ProductID') {
            const { filter, search, view, pagination, sort } = this.$refs[
                'product-list'
            ].$children[0]
            const retailerCatalogData = {
                filter,
                search,
                view,
                pagination,
                sort
            }

            localStorage.setItem(
                'retailer-catalog-data',
                JSON.stringify(retailerCatalogData)
            )
        } else {
            localStorage.removeItem('retailer-catalog-data')
        }*/
        localStorage.removeItem('retailer-catalog-data')

        next()
    },
    methods: {
        ...mapActions('publicCategories', ['getCategory', 'clearCategory']),
        showButtonNext() {
            const widthOfAllElements = this.$refs.swiperSlide.reduce(
                (acc, el) => acc + el.clientWidth,
                0
            )

            if (this.$refs.swiperContainer) {
                this.isButtonNext = !(
                    this.$refs.swiperContainer.clientWidth > widthOfAllElements
                )
            }
        }
    }
}
</script>
